import { memo } from "react";
import { ECommerce } from "ui/organizms/Onboarding";

const BankingAndFinance = () => (
    <ECommerce.BankingAndFinance />
);

export default memo(BankingAndFinance);
